import "../../styles/Modal.css"

function ExpoModal({ expo, order_id, onClose }) {

  return (
    <div className="m-overlay" >

      <div className="wm-content" >

        <div className="m-header" >
          <h4 className="m-title">Attention</h4>
          <button className="m-cancel-button-x" onClick={onClose}>X</button>
        </div>

        <div className="wm-body" >
          <span>Are you sure you want to EXPO this order?</span>
        </div>

        <div className="m-footer" >
          <div className="m-cancel-order-button-container">
            <button className="m-cancel-button" onClick={onClose} >No</button>
            <button className="m-order-button" onClick={() => expo(order_id)} >Yes</button>
          </div>
        </div>

      </div>

    </div>
  )
}

export default ExpoModal
